import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-icon-family',
	templateUrl:'./IconFamilyPluginCompPage.html',
	styles: [],
	styleUrls:['./IconFamilyPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class IconFamilyPluginCompPage
{
	mdContent_987 = `\`\`\`java
import com.jwebmp.plugins.fontawesome5.options.IconFamily;
\`\`\``;
}
